<script setup lang="ts">
import { slugify } from '@/utils/helpers'
interface Props {
  title: string
  tabIndex: number
  pills?: boolean
}
defineProps<Props>()

const selectedIndex = inject('selectedIndex')
</script>

<template>
  <div>
    <div class="tab-content--mobile" v-if="!pills">
      <h5>
        {{ title }}
      </h5>
      <slot />
    </div>
    <div
      v-show="selectedIndex === tabIndex"
      :hidden="!(selectedIndex === tabIndex)"
      role="tabpanel"
      tabindex="0"
      :aria-labelledby="slugify(title)"
      :class="['tab-content--desktop', { 'tab-content--desktop-pills': pills }]"
    >
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tab-content--mobile {
  display: flex;
  flex-direction: column;
  margin-bottom: var(--space80);
  @media (min-width: $breakpoint-lg) {
    display: none;
  }
}

.tab-content--desktop {
  display: none;
  @media (min-width: $breakpoint-lg) {
    display: flex;
    flex-direction: column;
  }

  &-pills {
    display: flex;
    flex-direction: column;
  }
}
</style>
